import React, {createRef} from "react";
import ReactDOM from "react-dom";
import { connect, Provider } from "react-redux";

//Authentication
import { login, getAccessToken, getLoggedInUser } from "../More/Actions/BookWorkspace/WorkspaceReservation/OfficeHotelingInterface";
import { ModalController } from "../../../common/components/Modal";

import Context from "../../../context/Context";
import Rdx from "../../../redux/Rdx";
import Topic from "../../../context/Topic";
import * as component from "../../util/component";
import FilterPopup from "../More/Actions/BookWorkspace/FilterPopup";
import { getHotelBookingSystem, getMeetingBookingSystem } from "../More/Actions/BookWorkspace/WorkspaceReservation/workspaceReservationUtil";
import {
  hideReservationsByFilter,
  showReservationsByFilter
} from "../More/Actions/BookWorkspace/WorkspaceReservation/reservationsLayerUtil";
import { resetMeetingCriteria } from "../MeetingRooms/MeetingRoomUtil";
import ReservationsErrorHandler from "../../../../src/aiim/util/ReservationsErrorHandler";
import MyMeetingRoomsOffice365 from "../MeetingRooms/MyMeetingRoomsOffice365";
import SidebarPanel from "./SidebarPanel";
import MeetingRooms from "../MeetingRooms/MeetingRooms";


const CSS = {
  sidebarButton: "i-sidebar-button",
  sidebarButtonActive: "i-sidebar-button-active",
  sidebarButtonCaption: "i-sidebar-button-caption",
  sidebarPanelOpen: "i-sidebar-panel-open",
  iconContainer: "i-sidebar-icon-container"
};

class SidebarButton extends React.Component {

  buttonRef = createRef();

  constructor(props) {
    super(props);
    this.state = component.newState({});
    this.clicked = this.clicked.bind(this);
  }

  showPopup = () => {
    this.togglePanel(false);
    if (this.props.sidebarKey !== "meetingRooms") {
      Topic.publish(Topic.BookingFiltersSubmit, { init: true });
    }
  }

  clicked(event) {
    const i18n = Context.instance.i18n
    const active = (this.props.sidebarKey === this.props.rdxSidebarActiveKey);
    const reservationTypeMeeting = Context.getInstance().config.workspaceReservation.reservationTypeMeeting;
    const reservationTypeHotel = Context.getInstance().config.workspaceReservation.reservationTypeHotel;

    Topic.publish(Topic.CloseSidebarPanel, {});

    // Check for errors with reservations
    if ((reservationTypeHotel === 'esri' && this.props.sidebarKey === "bookWorkspace")
        || (reservationTypeMeeting === 'esri' && this.props.sidebarKey === "meetingRooms")) {
      const reservations = Context.getInstance().aiim.datasets && Context.getInstance().aiim.datasets.reservations;
      let errorHandler = reservations && reservations.errorHandler;
      if (reservationTypeMeeting === 'esri' && this.props.sidebarKey === "meetingRooms") 
          errorHandler = reservations && reservations.errorHandlerMeetingRooms;
      
      const detailedErrors = errorHandler && errorHandler.getErrors();
      if (detailedErrors && detailedErrors.length > 0) {
        let generic = i18n.more.bookWorkspace.errors.header;
        if (reservationTypeMeeting === 'esri' && this.props.sidebarKey === "meetingRooms") generic = i18n.more.bookWorkspace.errors.meetinRooms.header;
        const errors = {
          generic: generic,
          detailed: detailedErrors.map((error) => error.getErrorMessage())
        };
        const options = { title: i18n.general.information, errors, className: 'i-portrait-access-hotel-error' };
        ModalController.showError(options);
        return;
      }
    }

    if(this.props.sidebarKey === "directions") {
      Topic.publish(Topic.UpdatePointBarriers, ()=>{})
    }

    if (this.props.sidebarKey === "bookWorkspace" || this.props.sidebarKey === "meetingRooms") {

      let bookingSystem;
      if (this.props.sidebarKey === "bookWorkspace") bookingSystem = getHotelBookingSystem();
      else if (this.props.sidebarKey === "meetingRooms") bookingSystem = getMeetingBookingSystem();

      const user = getLoggedInUser(bookingSystem)
      if (user) {
        getAccessToken(bookingSystem).then(token => {
          let isEsri = bookingSystem && bookingSystem.type === "esri"; // Issue #4425
          if (token || isEsri) {
            Topic.publish(Topic.BookingLogin, {})
            if (!active) {
              this.showPopup()
            } else {
              this.togglePanel(active)
            }
          } else {
            ModalController.showMessage(i18n.more.bookWorkspace.accessErrorMsg)
            console.error(i18n.more.bookWorkspace.accessErrorMsg)
          }
        }).catch(error => {
          ModalController.showMessage(i18n.more.bookWorkspace.accessErrorMsg)
          console.error(error)
        })
      } else {
        login(bookingSystem).then(result => {
          console.log(result)
          getAccessToken(bookingSystem).then(token => {
            if (token) {
              Topic.publish(Topic.BookingLogin, {})
              if (!active) {
                this.showPopup()
              } else {
                this.togglePanel(active)
              }
            } else {
              ModalController.showMessage(i18n.more.bookWorkspace.accessErrorMsg)
              console.error(i18n.more.bookWorkspace.accessErrorMsg)
            }
          }).catch(error => {
            ModalController.showMessage(i18n.more.bookWorkspace.accessErrorMsg)
            console.error(error)
          })
        }).catch(error => {
          ModalController.showMessage(i18n.more.bookWorkspace.accessErrorMsg)
          console.error(error)
        })
      }
    } else {
      this.togglePanel(active)
    }
  }

  togglePanel(active) {
    if (active) {
      hideReservationsByFilter();
      resetMeetingCriteria();

      Rdx.setValue(this,Rdx.Keys.SIDEBAR_ACTIVE_KEY,null);
      document.body.classList.remove(CSS.sidebarPanelOpen);
    } else {
      hideReservationsByFilter();
      resetMeetingCriteria();
      if (
        this.props.sidebarKey === "bookWorkspace" ||
        this.props.sidebarKey === "meetingRooms"
      ) {
        showReservationsByFilter();
      }

      Rdx.setValue(this,Rdx.Keys.SIDEBAR_ACTIVE_KEY,this.props.sidebarKey);
      document.body.classList.add(CSS.sidebarPanelOpen);
      Topic.publish(Topic.SidebarButtonClicked,{sidebarKey: this.props.sidebarKey});
    }
    Context.instance.views.toggleClickHandlers("resume");
  }

  componentDidMount() {
    component.own(this,[
      Topic.subscribe(Topic.SetSidebarButtonFocus,params => {
        if (params && params.sidebarKey === this.props.sidebarKey) {
          this._focus();
        }
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  _focus() {
    const btn = this.buttonRef && this.buttonRef.current;
    if (btn && btn.focus) btn.focus();
  }

  render() {
    const active = (this.props.sidebarKey === this.props.rdxSidebarActiveKey);
    let cls = null;
    if (active) cls = CSS.sidebarButtonActive;
    if (this.props.liClassName) {
      if (cls) cls += " " + this.props.liClassName;
      else cls = this.props.liClassName;
    }

    const icon = "libs/calcite-ui-icons/icons/sprite-16.svg#" + this.props.iconClassName;

    return (
      <li key={icon} className={cls}>
        <button title={this.props.tooltip} className={CSS.sidebarButton} aria-expanded={active}
         onClick={this.clicked} ref={this.buttonRef} aria-label={this.props.arialLabel}>
         <div className={CSS.iconContainer}>
            <svg className="icon"><use href={icon}></use></svg>
            <div className={CSS.sidebarButtonCaption}>{this.props.caption}</div>
         </div>
        </button>
      </li>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rdxSidebarActiveKey: Rdx.getValue(state,Rdx.Keys.SIDEBAR_ACTIVE_KEY)
  }
}

export default connect(mapStateToProps)(SidebarButton);
